import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Do you ship to all Hawaiian Islands?",
    a: "Yes — we ship to all Hawaiian Islands and the US Mainland."
  },
  {
    q: "What are the benefits of a magnesium recovery spray?",
    a: "Topical magnesium spray is absorbed through the skin and is commonly used for muscle recovery, cramp relief, better sleep, and stress reduction. Pō Mahina Magnesium Recovery Spray combines organic magnesium with kukui nut oil and calming essential oils (sandalwood, violet, cedar wood) to support rest and recovery."
  },
  {
    q: "How do I use Pō Mahina Magnesium Recovery Spray?",
    a: "Shake the bottle well (natural separation is normal). Directions: Spray 3–6 pumps onto clean skin on your legs, feet, shoulders, or lower back about 20 minutes before bed or after a workout. Massage in gently. Leave on overnight for best absorption."
  },
  {
    q: "Is your yoga mat cleaner safe for all mats?",
    a: "Yes — Lokahi Yoga Mat Cleaner is all-natural and non-toxic, safe for PVC, TPE, rubber, and cork mats. Made with organic witch hazel, sandalwood, and lavender essential oils. Spray on, wipe down, and enjoy the calming aromatherapy scent after every practice."
  },
  {
    q: "What is 'ALOHI Skin & Wellness?",
    a: "'ALOHI Skin & Wellness is a luxury Hawaiian skincare and wellness brand handcrafted with aloha. We create small-batch body oil, magnesium recovery spray, a natural yoga mat cleaner, and offer aesthetic services — all rooted in Polynesian beauty traditions with clean, natural ingredients."
  },
  {
    q: "Are your products natural, clean, and cruelty-free?",
    a: "Yes. Every 'ALOHI product is handcrafted in small batches with natural, carefully sourced ingredients — no harmful chemicals — and is cruelty-free."
  },
  {
    q: "Why does my oil or spray look separated?",
    a: "Natural separation is normal and a sign of pure, unprocessed ingredients. Simply shake the bottle well before each use."
  },
  {
    q: "Is topical magnesium better than a supplement?",
    a: "Topical magnesium spray is a popular alternative or complement to oral supplements because it's absorbed directly through the skin and can be applied precisely to sore or tense areas. It's especially useful at bedtime for relaxation and muscle recovery. Always consult your healthcare provider about your personal magnesium needs."
  },
  {
    q: "How do I contact 'ALOHI?",
    a: "Email us at veronica.gella@yahoo.com or DM @alohiskinandwellness on Instagram. Support hours are Mon–Fri 9 AM – 5 PM HST and Sat 10 AM – 3 PM HST."
  }
];

const FAQSection = () => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="section-padding faq-section" data-testid="faq-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">Frequently Asked Questions</h2>
          <p className="body-large section-subtitle">
            Everything you want to know about 'ALOHI Skin &amp; Wellness, our Hawaiian body oils, and our ingredients.
          </p>
        </div>

        <div
          className="faq-list"
          itemScope
          itemType="https://schema.org/FAQPage"
          data-testid="faq-list"
        >
          {FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className={`faq-item ${isOpen ? "is-open" : ""}`}
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                data-testid={`faq-item-${i}`}
              >
                <button
                  type="button"
                  className="faq-question"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  data-testid={`faq-question-${i}`}
                >
                  <span itemProp="name">{item.q}</span>
                  <ChevronDown
                    size={20}
                    className={`faq-chevron ${isOpen ? "rotated" : ""}`}
                    aria-hidden="true"
                  />
                </button>
                <div
                  id={`faq-answer-${i}`}
                  className="faq-answer"
                  role="region"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                  hidden={!isOpen}
                >
                  <p itemProp="text" className="body-regular">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
